/* eslint-disable no-case-declarations */
import actionTypes from "_constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.GET_AREA_STUDENT_DATA:
            return {
                ...state,
                getStudentArea: action.payload,
                getStudentAreaError: null
            };
        case actionTypes.GET_AREA_STUDENT_ERROR:
            return {
                ...state,
                getStudentArea: null,
                getStudentAreaError:  action.payload
            };
        case actionTypes.SAVE_AREA_DATA:
            return {
                ...state,
                saveArea: action.payload,
                saveAreaError: null
            };
        case actionTypes.SAVE_AREA_ERROR:
            return {
                ...state,
                saveArea: null,
                saveAreaError: action.payload
            };
        case actionTypes.CLEAR_SAVE_AREA:
            return {
                ...state,
                saveArea: null,
                saveAreaError: null,
            };
        case actionTypes.GET_ANSWERS_DATA:
            return {
                ...state,
                answersData: action.payload,
                answersDataPreNext: action.payload,
                answersDataError: null
            };
        case actionTypes.GET_ANSWERS_DATA_V2:
            let answersDataNext = action.payload || [];
            let answersDataPre = state.answersDataPreNext || [];

            let answersData = answersDataNext.map(it => {
                const exist = answersDataPre.find(iti =>  iti.assessment_id === it.assessment_id)
                if (exist) return {...exist, ...it, assessment: exist.assessment}
                return it
            })

            return {
                ...state,
                answersDataPreNext: answersData,
                answersData: answersData,
                answersDataError: null
            };
        case actionTypes.GET_ANSWERS_ERROR:
            return {
                ...state,
                answersData: null,
                answersDataError: action.payload,
            };
        case actionTypes.CLEAR_DATA_ANSWER:
            return {
                ...state,
                answersData: null,
                answersDataError: null
            };

        case actionTypes.SAVE_ANSWER_DATA:
            return {
                ...state,
                saveAnswer: action.payload,
                saveAnswerError: null
            };
        case actionTypes.SAVE_ANSWER_ERROR:
            return {
                ...state,
                saveAnswer: null,
                saveAnswerError: action.payload,
            };
        case actionTypes.CLEAR_ANSWER:
            return {
                ...state,
                saveAnswer: null,
                saveAnswerError: null,
            };

        case actionTypes.GET_ASSESSMENTS_CODE_DATA:

            return {
                ...state,
                assestmentsCodeData: action.payload,
                assestmentsCodeDataError: null
            };
        case actionTypes.GET_ASSESSMENTS_CODE_ERROR:
            return {
                ...state,
                assestmentsCodeData: null,
                assestmentsCodeDataError: action.payload,
            };
        case actionTypes.CLEAR_ASSESSMENTS_CODE:

            return {
                ...state,
                assestmentsCodeData: null,
                assestmentsCodeDataError: null,
            };
        case actionTypes.GET_ASSESSMENTS_DATA:

            return {
                ...state,
                assestmentsData: action.payload,
                assestmentsDataError: null
            };
        case actionTypes.GET_ASSESSMENTS_ERROR:
            return {
                ...state,
                asestmentsData: null,
                asestmentsDataError: action.payload,
            };
        case actionTypes.GET_QUESTIONNAIRES_DATA:

            return {
                ...state,
                questionnairesData: action.payload,
                questionnairesDataError: null
            };
        case actionTypes.GET_QUESTIONNAIRES_ERROR:
            return {
                ...state,
                questionnairesData: null,
                questionnairesDataError: action.payload,
            };

        case actionTypes.GET_QUESTIONNAIRE_DATA:
            return {
                ...state,
                questionnaireData: action.payload,
            };
        case actionTypes.GET_QUESTIONNAIRE_ERROR:
            return {
                ...state,
                questionnaireDataError: action.payload,
            };

        case actionTypes.DELETE_ANSWER_DATA:
            return {
                ...state,
                deleteAnswerData: action.payload,
            };
        case actionTypes.CLEAR_DELETE_ANSWER_DATA:
            return {
                ...state,
                deleteAnswerData: null,
            };
        case actionTypes.GET_RESPONSES_DATA:
            return {
                ...state,
                responsesData: action.payload
            }
        case actionTypes.GET_RESPONSE_DATA:
            return {
                ...state,
                responseData: {
                    ...state.responseData,
                    [action.payload.id]:action.payload
                }
            }
        default:
            return state;
    }
};
